import React, {useState} from 'react';
import axios from 'axios'
import {Link} from 'react-router-dom'
import { FormGroup, Input, Button } from 'reactstrap';
import ModalImage from '../modalImage/ModalImage';
import { useHistory, Redirect } from 'react-router-dom';
import Gps from '../../images/gps.png'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Info from '../../images/info.png'
import DeleteLoc from '../..//images/deleteLoc.png'
import Logo from '../../images/logo2.png'
import './interet.css'


const Interet = () => {

    const [event, setEvent] = useState({
        name: '',
        position: '',
        mission: '',
        status: 0,
    
    })

    let history = useHistory()

    const cleansStorage = () => {
        sessionStorage.removeItem(`position`)
        history.push('/interet')
    }

    const popupValidate = () => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: `La demande de signalisation d'un point d'interêt a bien était soumise !`,
            showConfirmButton: false,
            timer: 3000
        })
    }

    const popupLogToi = () => {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: `Connecte Toi !`,
            showConfirmButton: true,

        })
        history.push("/login")
    }

    const popupInfo = () => {
        Swal.fire({
            title: "Ici, vous pouvez signaler un endroit défini comme «pollué», pour que les cleaners le remarque et puissent organiser un évènement depuis votre signalement.",
            showConfirmButton: true,
            customClass: {
                confirmButton: 'button',
            },

        })
    }



    const queryData = (e) => {
        e.preventDefault()
        console.log(event)
        axios.post("https://clean-my-calanques.herokuapp.com/events", event)
            .then(x => popupValidate())
            .then(res => {
                history.push('/mappy')
            })
            .catch(err => console.log(err))
            console.log(event)
    }

    const geoloc = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            sessionStorage.setItem('position', String(position.coords.latitude) + ',' + String(position.coords.longitude) )
            setEvent({ ...event, position: String(position.coords.latitude) + ',' + String(position.coords.longitude) })
            Swal.fire({
                icon: 'success',
                title: `Géolocalisation validée !`,
                showConfirmButton: false,
                timer: 2000
            })
            .then(res => {
                history.push('/interet')
            })

        })

    }
 

    return (
        < div className="containerAdd">
        <div className="containerCitation">
            <img src={Logo} alt="logo" width="80%" />
        <blockquote>
            <p>Cela semble toujours impossible, jusqu'a ce qu'on le fasse</p>
            <footer>—Nelson Mandela</footer>
        </blockquote>

    </div>
    <div class="containerForm">
         <div className="tabsContainer">
       <Link className="eventTab" to="/addEvent" onClick={() =>  cleansStorage()}>Organiser</Link>
        <Link className="interetTab" to="/interet" onClick={() =>  cleansStorage()}>Signaler</Link>
        </div>  

            {localStorage.userId ? (
                <div className='formInteret'>
                    <Button onClick={popupInfo} className="infoInteret"><img src={Info} className="infoInteret" /></Button>
                    <div className="titleEvent">
                        <h1 className='event'>Créer un point d'Interet ! </h1>
                        <img className='event-pin' src='https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png' height="30px" alt="pin" />
                    </div>
                    <form onSubmit={queryData} >
                        <input placeholder="Nom" name='name' value={event.name} required type='text' onChange={(e) => setEvent({ ...event, name: e.target.value })} />
                        {sessionStorage.position ?  (
                            <Button className="locationButton" onClick={() =>  cleansStorage()} >Annuler ma Geolocalisation<img className="gpsImage" src={DeleteLoc} alt="gpsImage" /></Button>
                        ):(
                            <>
                            <FormGroup className="select" >
                                <Input type="select" name="lat" value={event.position} id="lat" onChange={(e) => setEvent({ ...event, position: e.target.value })}>

                                    <option value="">Sélectionne le lieu à cleaner !</option>
                                    <option value="43.2022837,5.4981386">Calanque d'En-Vau</option>
                                    <option value="43.211936,5.45426">Calanque de Sugiton</option>
                                    <option value="43.2099964,5.4201922">Calanque de Sormiou</option>
                                    <option value="43.2162375,5.4088463">Col de Sormiou</option>
                                    <option value="43.2021482,5.452113">Cap Morgiou</option>
                                    <option value="43.203846,5.5108943">Calanque de Port-pin</option>
                                    <option value="43.2109812,5.5207709">Calanque voisine Port-miou</option>
                                    <option value="43.2251324,5.3467818">Calanque de l'Escalette</option>
                                    <option value="43.2271236,5.348432">Calanque du Mauvais-Pas</option>
                                    <option value="43.2091829,5.3607088">Calanque de la Mounine</option>
                                    <option value="43.207377,5.3625095">Îlot de la Mounine</option>
                                    <option value="43.2232514,5.3717564">Sommet de Marseileveyre</option>
                                    <option value="43.209582,5.3725388">Calanque de Marseilleveyre</option>
                                    <option value="43.222039,5.459125">Mont Puget</option>
                                    <option value="43.2228072,5.3702515">Massif de Marseilleveyre</option>
                                    <option value="43.2218694,5.3762356">Col de la Selle</option>
                                    <option value="43.2041444,5.4266722">Bec de Sormiou</option>
                                    <option value="43.1757179,5.1055834">Archipel du Riou</option>
                                    <option value="43.1939184,5.5357805">Cap Canaille</option>
                                    <option value="43.2137037,5.3226357">Calanque de Podestat</option>
                                    <option value="43.2106539,5.377845">Calanque des Queyrons</option>
                                    <option value="43.2116534,5.3728895">Calanque de l'Escu</option>
                                    <option value="43.2068413,5.4254247">Cap Redon</option>
                                    <option value="43.2050802,5.4259941">Grotte du Capelan</option>
                                    <option value="43.2126164,5.4177014">Crête de Morgiou</option>
                                    <option value="43.2027519,5.4468749">Grotte préhistorique Cosquer</option>
                                    <option value="43.2109604,5.4283435">Calanque de Morgiou</option>
                                    <option value="43.2022859,5.4497039">Calanque de la Triperie</option>
                                    <option value="43.2102599,5.4479192">Grotte Bleue</option>
                                    <option value="43.2078413,5.4677493">Calanque de l'Oeil de Verre</option>
                                    <option value="43.2078413,5.4677493">Calanque de St Jean de Dieu</option>
                                    <option value="43.2122274,5.4488195">Grande Candelle</option>
                                    <option value="43.2129584,5.4487115">Col de la Candelle</option>
                                    <option value="43.2110453,5.3734512">Calanque du Devenson</option>
                                    <option value="43.2027754,5.4719055">Calanque de l'Eissadon</option>
                                    <option value="43.2025094,5.4754804">Calanque de l'Oule</option>
                                    <option value="43.199332,5.5347275">Belvédère des Calanques</option>
                                    <option value="43.3344634,5.2113471">Calanque de Niolon</option>
                                    <option value="43.2115324,5.3348095">Calanque de Callelongue</option>
                                    <option value="43.2141828,5.3375872">Baie des singes</option>
                                    <option value="43.282976,5.3457861">Malmousque</option>
                                    <option value="43.2285674,5.3311305">Calanque de Saména</option>
                                    <option value="43.2236904,5.3283294">Calanque Blanche</option>
                                    <option value="43.2132964,5.3845945">Calanque de Cortiou</option>
                                    <option value="43.2060384,5.4401588">Calanque du Cancéou</option>
                                    <option value="43.2550884,5.3559085">Plages du Prado</option>
                                    <option value="43.2731376,5.3599173">Plage du Prophète</option>
                                    <option value="43.2907013,5.3532104">Plage des Catalans</option>
                                    <option value="43.3315139,5.0689821">Plage de Sainte Croix</option>
                                    <option value="43.2446853,5.3688878">Plage de la Pointe Rouge </option>
                                    <option value="43.2151874,5.3244175">Anse de la Maronaise</option>
                                    <option value="43.3581647,5.2853801">Plages de Corbières</option>
                                    <option value="43.2566511,5.3742494">Plage Borély</option>
                                    <option value="43.2640149,5.368005">Plage Prado Nord</option>
                                    <option value="43.2617179,5.370001">Plage Prado Sud</option>
                                    <option value="43.259731,5.3727828">Plage de l'Huveaune (David)</option>
                                    <option value="43.3306704,5.2147026">Calanque de Méjéan</option>
                                    <option value="43.2315323,5.3356765">Plage Verrerie</option>
                                    <option value="43.0777411,5.8840288">Plage des Sablettes</option>
                                    <option value="43.2381835,5.361088">Plage de l’Abri Côtier</option>
                                    <option value="43.2574447,5.3289775">Anse du Phocéen</option>
                                    <option value="43.2398561,5.3601771">Plage Bain des Dames</option>
                                    <option value="43.2804844,5.3505537">Plage de la Fausse Monnaie</option>
                                    <option value="43.2800475,5.3500797">Plage du Petit Nice</option>
                                    <option value="43.2804734,5.3480677">Plage de Maldormè</option>
                                    <option value="43.2854763,5.3491096">Vallon des Auffes</option>
                                    <option value="43.3585707,5.2919019">Plage de La Lave</option>
                                    <option value="43.2501084,5.3560175">Plage de la Vieille Chapelle</option>
                                    <option value="43.2841861,5.3135262">Plage Saint-Estève</option>
                                </Input>

                                <hr className="hr-event" data-content="OU" />

                            </FormGroup>

                        <Button className="locationButton" onClick={geoloc} >Me geolocaliser<img className="gpsImage" src={Gps} alt="gpsImage" /></Button>
                        </>
                        
                        )
                        
                        }
                        <input className="mission" placeholder='Décrit la mission...' name='mission' value={event.mission} required type='text' onChange={(e) => setEvent({ ...event, mission: e.target.value })} />
                        <ModalImage event={event} setEvent={setEvent} />

                        <button className="button" type="submit" >
                            Ajoute ton point d'interêt !
                </button>
                    </form>

                </div>
            ) : (
                    popupLogToi()

                )}
        </div>
        </div>
    )
}

export default Interet;